import Vue from 'vue'
import Vuex from 'vuex'
import results from './modules/result'
import history from './modules/history'
import ui from './modules/ui'
import language from './modules/language'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    results,
    history,
    ui,
    language
  },
  state: {
    modalOpen: false
  },
  getters: {
    isModalOpen: state => state.modalOpen
  },
  mutations: {
    updateModalStatus (state, status) {
      state.modalOpen = status
      if (status) {
        document.documentElement.style.overflow = 'hidden'
      } else {
        document.documentElement.style.overflow = 'auto'
      }
    }
  }
})
